<template>
    
    <Card class="w-full">
        <template #title>
            Esqueci minha senha
        </template>
        <template #content>
            <form @submit.prevent="login(form)">
                <div class="field mt-4">
                    <FloatLabel>
                        <InputText id="login" v-model="form.login" class="w-full" />
                        <label for="login">Login/E-mail</label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['login'] }}</div>
                </div>
                <Button 
                    type="submit" 
                    label="Entrar" 
                    icon="pi pi-check" 
                    class="w-full mt-4" 
                    :loading="isLoading" />
            </form>
        </template>
    </Card>
</template>

<script>
import Card from 'primevue/card';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Button from 'primevue/button';

import Auth from '@/service/auth.js';
import Token from '@/utils/Token.js';

export default {
    components: {
        Card,
        FloatLabel,
        InputText,
        Password,
        Button,
    },
    data() {
        return {
            form: {},
            errors: {},
            isLoading: false,
        }
    },
    methods: {
        login(form) {
            this.errors = {};
            this.isLoading = true;

            Auth.esqueciSenha(form)
                .then(response => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso!', detail: `O e-mail de recuperação de senha foi enviado! Verifique na sua caixa de entrada e no lixo eletronico.`, life: 3000 });
                    this.$router.push('/login');
                })
                .catch(error => {
                    if(error.response) {
                        let err = error.response.data;
                        if(err.erros) {
                            for(let i in err.erros) {
                                this.errors[i] = err.erros[i][0];
                            }
                            return;
                        }
                        if(error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>